import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

productCountStyles.wrapper = {
    css: css`
        margin-top: 10px;
        margin-left: 20px;
        ${({ theme }) => {
            return breakpointMediaQueries(
                theme,
                [
                    css`
                        margin-bottom: 10px;
                        margin-left: 0px;
                    `,
                    css`
                        margin-bottom: 10px;
                        margin-left: 0px;
                    `,
                    null,
                    null,
                ],
                "minMax",
            );
        }}
    `,
};
